import React, { Component } from 'react'
import Footer from '../../../../_components/common/Footer';
import NavBar from '../../../../_components/common/Navbar';
import ModalNew2 from '../../../../_components/common/ModalNew2';
import { CommonBreadCrumb } from '../../../../_components/common/CommonBreadCrumb'
import { validation, cellValidation } from '../../UploadDemographicData/validation';
import { HotTable } from '@handsontable/react';
import 'handsontable/dist/handsontable.full.css'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../../../_components/common/Form2/index.css';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { connect } from 'react-redux';
import * as Papa from 'papaparse';
import PropTypes from 'prop-types';
import { UploadAssessmentAction } from '../../../../_actions/organisations/UploadAssessmentAction.action';
import { organisationAction } from '../../../../_actions/organisation.action';
import { manageBatchActions } from '../../../../_actions/organisations/manageBatchList.action';
import './../../UploadDemographicData';
import './uploadAssessment.css';
import Page404 from '../../../404page';
import { LoaderComp } from '../../../../_components/common/LoaderComp/Loadercomp';


class UploadAssessment extends Component {
    state = {


        orgId: 0,
        sellerId: 0,

        batchList: [],

        chooseFile: false,
        csvData: [],
        validateDisability: false,
        uploadDisability: false,
        csvErrorPosition: {},
        work_experience: 50,
        validationText: 'VALIDATE',


        currentInstrumentId: 0,

        relationDataArr: [],
        relationDataArrFull: [],

        readOnlyCsv: false,


        hasProperOrgId: true,
        idLoader: true,

        errSaveIndex: [],

        uploadButtonLoader: false
    }

    componentDidMount() {

        const { dispatch } = this.props;

        dispatch(organisationAction.getOrganisation((callback_Data) => {
            let hasId = false
            for (let i = 0; i < callback_Data.data.organisation_list.length; i++) {
                const element = callback_Data.data.organisation_list[i];
                if (element.id == orgIdFromPath) {
                    hasId = true
                }
            }

            this.setState({
                hasProperOrgId: hasId,
                idLoader: false,
            })
        }))

        let orgIdFromPath = this.props.location.pathname.match(/\d/g);
        orgIdFromPath = orgIdFromPath.join("");
        this.setState({
            orgId: parseInt(orgIdFromPath, 10)
        })
    }

    componentDidUpdate(prevProps) {
        this.handleDemoGraphicCsvUploadChange(prevProps);
        this.handleOrganisationListChange(prevProps);
    }

    handleDemoGraphicCsvUploadChange(prevProps) {
        const { demoGraphicCsvUpload } = this.props;
        if (prevProps.demoGraphicCsvUpload !== demoGraphicCsvUpload) {
            if (!demoGraphicCsvUpload.demoGraphicCsvUpload_error && !demoGraphicCsvUpload.demoGraphicCsvUpload_loading) {
                this.showSuccessToast();
            } else if (demoGraphicCsvUpload.demoGraphicCsvUpload_error) {
                this.showErrorToast();
            }
        }
    }

    showSuccessToast() {
        let toastId = toast.info(`CSV UPLOADED SUCCESSFULLY`, {
            position: toast.POSITION.BOTTOM_LEFT,
            autoClose: 1500,
        });

        toast.update(toastId, {
            render: `CSV UPLOADED SUCCESSFULLY`,
            type: toast.TYPE.INFO,
            className: 'styleToastSuccess'
        });
    }

    showErrorToast() {
        toast.error(`CSV UPLOAD FAILED`, {
            position: toast.POSITION.BOTTOM_LEFT,
            autoClose: 1500,
        });
    }

    handleOrganisationListChange(prevProps) {
        if (prevProps.organisationList !== this.props.organisationList && this.props.organisationList.length !== 0) {
            const { sellerId, relationDataArr, relationDataArrFull } = this.processOrganisationList();
            this.updateStateAndDispatchActions(sellerId, relationDataArr, relationDataArrFull);
        }
    }

    processOrganisationList() {
        let sellerId = 0;
        let relationDataArr = [];
        let relationDataArrFull = [];

        for (const element of this.props.organisationList) {
            if (element.id === this.state.orgId) {
                sellerId = element.seller__id;
                for (const elem of element.assessor_group) {
                    relationDataArrFull.push(elem);
                    relationDataArr.push(elem.assessor_group__assessor_name);
                }
                break;
            }
        }

        return { sellerId, relationDataArr, relationDataArrFull };
    }

    updateStateAndDispatchActions(sellerId, relationDataArr, relationDataArrFull) {
        this.setState({
            sellerId,
            relationDataArr,
            relationDataArrFull
        }, () => {
            const { dispatch } = this.props;
            const { orgId } = this.state;

            dispatch(manageBatchActions.getBatchList({ orgId, sellerId }));
            dispatch(manageBatchActions.allotAssessmentInstrumentListAction({ sellerId, orgId }));
        });
    }

    chooseFileFunc = (showModal) => {
        this.setState({
            chooseFile: showModal
        })
    }
    chooseFileAction = (data) => {
        // Check if the file is a CSV
        if (!data.name.toLowerCase().endsWith('.csv')) {
            this.handleInvalidFileType();
            return;
        }

        let that = this;
        Papa.parse(data, {
            complete: function (results) {
                if (results.data.length === 0 || (results.data.length === 1 && results.data[0].every(cell => cell === ''))) {
                    that.handleEmptyFile();
                    return;
                }

                const headers = results.data[0];
                const requiredColumns = ['user_email', 'respondent_email', 'relation_name', 'full_name', 'short_name', 'gender'];
                const missingColumns = requiredColumns.filter(col => !headers.includes(col));

                if (missingColumns.length > 0) {
                    that.handleMissingColumns(missingColumns);
                    return;
                }

                if (results.data.length === 1) {
                    that.handleOnlyHeaderRow();
                    return;
                }

                let __validCsv = headers.length;
                const nonEmptyRows = results.data.filter((row, index) => index === 0 || row.some(cell => cell !== ''));

                if (nonEmptyRows.length === 1) {
                    that.handleOnlyHeaderRow();
                    return;
                }

                that.processValidCsv(nonEmptyRows);
            }
        });
    }

    handleInvalidFileType = () => {
        this.setState({
            csvData: [],
            errSaveIndex: [],
            validateDisability: false,
        }, () => {
            toast.error(`Please upload a CSV file`, {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 3000,
            });
        });
    }

    handleEmptyFile = () => {
        this.setState({
            csvData: [],
            errSaveIndex: [],
            validateDisability: false,
        }, () => {
            toast.error(`The uploaded file is empty`, {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 3000,
            });
        });
    }

    handleMissingColumns = (missingColumns) => {
        this.setState({
            csvData: [],
            errSaveIndex: [],
            validateDisability: false,
        }, () => {
            toast.error(`Missing required columns: ${missingColumns.join(', ')}`, {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 3000,
            });
        });
    }

    handleOnlyHeaderRow = () => {
        this.setState({
            csvData: [],
            errSaveIndex: [],
            validateDisability: false,
        }, () => {
            toast.error(`The CSV file only contains a header row and no data`, {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 3000,
            });
        });
    }

    processValidCsv = (data) => {
        this.setState({
            csvData: data,
            errSaveIndex: [],
        }, () => {
            if (this.state.currentInstrumentId !== 0) {
                this.setState({
                    validateDisability: true
                });
            }
        });

        this.setState({
            validationText: 'VALIDATE',
            readOnlyCsv: false,
            uploadDisability: false,
        });
    }

    capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }




    validateCsvFunc = () => {
        const newValidationText = this.getNewValidationText();
        this.updateStateForValidation(newValidationText);

        setTimeout(() => {
            this.handleValidationTimeout(newValidationText);
        }, 1300);
    }

    getNewValidationText = () => {
        return this.state.validationText === 'VALIDATE' ? 'VALIDATING...' : 'GETTING CSV READY TO EDIT...';
    }

    updateStateForValidation = (newValidationText) => {
        this.setState({
            readOnlyCsv: false,
            uploadDisability: false,
            validateDisability: !this.state.validateDisability,
            validationText: newValidationText
        });
    }

    handleValidationTimeout = (validationText) => {
        if (validationText === 'VALIDATING...') {
            this.handleValidating();
        } else if (validationText === 'GETTING CSV READY TO EDIT...') {
            this.prepareForEditing();
        }
        this.toggleValidateDisability();
    }

    handleValidating = () => {
        const updatedCsvData = this.capitalizeRelationNames();
        this.setState({ csvData: updatedCsvData }, this.performValidation);
    }

    capitalizeRelationNames = () => {
        return this.state.csvData.map((row, index) => {
            if (index === 0) return row; // Skip header row
            return row.map((cell, cellIndex) => {
                if (this.state.csvData[0][cellIndex] === 'relation_name') {
                    return this.capitalizeFirstLetter(cell);
                }
                return cell;
            });
        });
    }

    toggleValidateDisability = () => {
        this.setState({
            validateDisability: !this.state.validateDisability,
        });
    }

    performValidation = () => {
        if (this.state.csvData.length <= 1) {
            this.handleEmptyOrHeaderOnlyFile();
            return;
        }

        const { isValid, saveIndex, duplicateEmails, emptyFields } = this.validateCsvData();

        if (isValid) {
            this.handleSuccessfulValidation();
        } else {
            this.handleFailedValidation(saveIndex, duplicateEmails, emptyFields);
        }
    }

    validateCsvData = () => {
        const csvArray = this.csvJSON(this.state.csvData);
        const { isValid, saveIndex, duplicateEmails, emptyFields } = this.processRows(csvArray);
        return { isValid, saveIndex, duplicateEmails, emptyFields };
    }

    processRows = (csvArray) => {
        let isValid = true;
        const saveIndex = [];
        const emailSet = new Set();
        const duplicateEmails = new Set();
        const emptyFields = [];

        csvArray.forEach((row, rowIndex) => {
            if (rowIndex === 0) return; // Skip header row

            const result = this.processRow(row, rowIndex, emailSet);
            isValid = isValid && result.isValid;
            if (result.saveColumnIndex.length > 0) {
                saveIndex.push({ col: result.saveColumnIndex, row: rowIndex + 1 });
            }
            result.duplicateEmails.forEach(email => duplicateEmails.add(email));
            emptyFields.push(...result.emptyFields);
        });

        return { isValid, saveIndex, duplicateEmails, emptyFields };
    }

    processRow = (row, rowIndex, emailSet) => {
        let isValid = true;
        const saveColumnIndex = [];
        const duplicateEmails = new Set();
        const emptyFields = [];

        Object.entries(row).forEach(([key, value], colIndex) => {
            if (this.isEmptyField(value)) {
                this.handleEmptyField(saveColumnIndex, emptyFields, rowIndex, colIndex, key);
                isValid = false;
            } else if (key === 'user_email') {
                isValid = this.handleUserEmail(value, emailSet, duplicateEmails, saveColumnIndex, colIndex) && isValid;
            } else if (key === 'respondent_email') {
                isValid = this.handleRespondentEmail(value, saveColumnIndex, colIndex) && isValid;
            } else if (key === 'relation_name') {
                isValid = this.handleRelationName(value, saveColumnIndex, colIndex) && isValid;
            }
        });

        return { isValid, saveColumnIndex, duplicateEmails, emptyFields };
    }

    isEmptyField = (value) => value === '' || value === undefined;

    handleEmptyField = (saveColumnIndex, emptyFields, rowIndex, colIndex, key) => {
        saveColumnIndex.push(colIndex);
        emptyFields.push(`Row ${rowIndex + 2}, Column ${key}`);
    }

    handleUserEmail = (value, emailSet, duplicateEmails, saveColumnIndex, colIndex) => {
        let isValid = true;
        if (emailSet.has(value)) {
            duplicateEmails.add(value);
            saveColumnIndex.push(colIndex);
            isValid = false;
        } else {
            emailSet.add(value);
        }
        if (!validation.isEmailAddress(value)) {
            saveColumnIndex.push(colIndex);
            isValid = false;
        }
        return isValid;
    }

    handleRespondentEmail = (value, saveColumnIndex, colIndex) => {
        if (!validation.isEmailAddress(value)) {
            saveColumnIndex.push(colIndex);
            return false;
        }
        return true;
    }

    handleRelationName = (value, saveColumnIndex, colIndex) => {
        if (!this.checkIfProperRelationFiller(value)) {
            saveColumnIndex.push(colIndex);
            return false;
        }
        return true;
    }

    handleEmptyOrHeaderOnlyFile = () => {
        toast.error('The CSV file is empty or contains only a header row', {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 3000,
        });
        this.setState({
            csvData: [],
            errSaveIndex: [],
            validateDisability: false,
            validationText: 'VALIDATE',
        });
    }

    handleSuccessfulValidation = () => {
        toast.info('CSV VALIDATED SUCCESSFULLY', {
            position: toast.POSITION.BOTTOM_LEFT,
            autoClose: 1500,
        });
        this.setState({
            readOnlyCsv: true,
            uploadDisability: this.state.currentInstrumentId !== 0,
            validationText: 'EDIT CSV'
        });
    }

    handleFailedValidation = (saveIndex, duplicateEmails, emptyFields) => {
        const errorMessages = [];
        if (duplicateEmails.size > 0) {
            errorMessages.push(`Duplicate emails found: ${Array.from(duplicateEmails).join(', ')}`);
        }
        if (emptyFields.length > 0) {
            errorMessages.push(`Empty fields found: ${emptyFields.join(', ')}`);
        }
        errorMessages.push('CSV VALIDATION FAILED');

        toast.error(errorMessages.join('\n'), {
            position: toast.POSITION.BOTTOM_LEFT,
            autoClose: 5000,
        });

        this.showErrorHighlightHOT(saveIndex);
        this.setState({
            readOnlyCsv: true,
            uploadDisability: false,
            validationText: 'EDIT CSV'
        });
    }

    prepareForEditing = () => {
        this.setState({
            readOnlyCsv: false,
            uploadDisability: false,
            validationText: 'VALIDATE'
        });
    }

    showErrorHighlightHOT = (saveIndex) => {
        this.setState({ errSaveIndex: saveIndex });
    }

    checkIfProperRelationFiller = (elementData) => {
        return elementData !== undefined &&
            elementData.length !== 0 &&
            this.state.relationDataArrFull.some(element =>
                element.assessor_group__assessor_name === elementData
            );
    }

    csvJSON = (csv) => {
        const lines = csv;
        const result = [];
        const headers = lines[0];

        for (let i = 1; i < lines.length; i++) {
            const obj = {};
            const currentline = lines[i];

            for (let j = 0; j < headers.length; j++) {
                obj[headers[j]] = currentline[j];
            }
            result.push(obj);
        }
        return result;
    }

    cellbeforechange = (c, s) => {

        this.state.csvData[c[0][0]][c[0][1]] = c[0][3]

        let editedErrored = false

        this.state.errSaveIndex.forEach(indexes => {
            indexes.col.forEach(colD => {
                if (c[0][0] === indexes.row && c[0][1] === colD) {
                    if (c[0][2] !== c[0][3]) {
                        editedErrored = true;
                    }
                }
            });
        });

        if (editedErrored) {
            const errorIndexArr = this.state.errSaveIndex.map(indexes => {
                return {
                    ...indexes,
                    col: indexes.col.filter(colD => {
                        return indexes.row !== c[0][0] || (indexes.row === c[0][0] && colD !== c[0][1])
                    })
                }
            })

            this.setState({
                errSaveIndex: errorIndexArr
            })
        }
    }

    showErrorHighlightHOT(saveIndex) {
        this.setState({
            errSaveIndex: saveIndex,
        })
    }



    hotAfterValidate = (isValid, value, row, prop, source) => {

    }

    uploadCsvFunc = () => {
        const { dispatch } = this.props;
        const csvJson = this.csvJSON(this.state.csvData);
        const uploadingCsvData = this.prepareUploadingCsvData(csvJson);
        const uploadingData = this.createUploadingData(uploadingCsvData);

        this.dispatchUploadAction(dispatch, uploadingData);

        this.setState({
            uploadButtonLoader: true,
            currentInstrumentId: 0
        });
    }

    prepareUploadingCsvData = (csvJson) => {
        return csvJson.map(element => {
            const relationId = this.findRelationId(element.relation_name);
            return this.createUploadingCsvDataItem(element, relationId);
        });
    }

    findRelationId = (relationName) => {
        const relation = this.state.relationDataArrFull.find(
            elem => elem.assessor_group__assessor_name === relationName
        );
        return relation ? relation.assessor_group : 0;
    }

    createUploadingCsvDataItem = (element, relationId) => ({
        action: element.action,
        user_email: element.user_email,
        respondent_email: element.respondent_email,
        relation: relationId,
        full_name: element.full_name || '',
        short_name: element.short_name || '',
        gender: this.determineGender(element.gender)
    })

    determineGender = (gender) => {
        if (gender === undefined) return 3;
        return gender === 'Male' ? 1 : gender === 'Female' ? 2 : 3;
    }

    createUploadingData = (uploadingCsvData) => ({
        organisation: this.state.orgId,
        seller: this.state.sellerId,
        instrument: this.state.currentInstrumentId,
        details: uploadingCsvData
    })

    dispatchUploadAction = (dispatch, uploadingData) => {
        dispatch(UploadAssessmentAction.UploadRespondentActionApi(
            uploadingData,
            {
                sellerId: this.state.sellerId,
                orgId: this.state.orgId
            },
            manageBatchActions.allotAssessmentInstrumentListAction,
            this.handleUploadResponse
        ));
    }

    handleUploadResponse = (UploadRespondentActionApi_Data) => {
        if (UploadRespondentActionApi_Data && UploadRespondentActionApi_Data.data.errors.length === 0) {
            this.setState({
                csvData: [],
                errSaveIndex: []
            });
        }
        this.setState({
            uploadButtonLoader: false
        });
    }

  

    chooseInstrument = (e) => {
        if (e.target.value !== 'Choose an Option...') {
            this.setState({
                currentInstrumentId: parseInt(e.target.value)
            }, () => {
                if (this.state.validateDisability === false && this.state.csvData.length > 0) {
                    this.setState({
                        validateDisability: true
                    })
                }
                if (this.state.validationText === 'EDIT CSV' && this.state.uploadDisability === false) {
                    this.setState({
                        uploadDisability: true,
                    })
                }
            })
        } else {
            this.setState({
                uploadDisability: false,
                currentInstrumentId: 0,
                validateDisability: false,
                readOnlyCsv: false,
                validationText: 'VALIDATE'
            })
        }
    }

    toggle = () => {
        const { dispatch } = this.props;

        this.setState({
            uploadDisability: !this.state.uploadDisability
        }, () => {
            dispatch({
                type: 'REQUEST_UPLOAD_RESPONDENT_API',
            })
        })
    }



    render() {
        const { uploaded_respondent_error, uploaded_respondent_data, uploaded_respondent_error_data, instrumentList } = this.props;
        const { idLoader, hasProperOrgId,  chooseFile } = this.state;

        return (
            <div className="position-relative custom-container">
                <NavBar />
                {this.renderContent(idLoader, hasProperOrgId, uploaded_respondent_error, uploaded_respondent_data, uploaded_respondent_error_data, instrumentList)}
                {this.renderChooseFileModal(chooseFile)}
                <Footer />
            </div>
        );
    }

    renderContent(idLoader, hasProperOrgId, uploaded_respondent_error, uploaded_respondent_data, uploaded_respondent_error_data, instrumentList) {
        if (idLoader) {
            return this.renderLoader();
        }
        if (!hasProperOrgId) {
            return <Page404 />;
        }
        return (
            <div className="container" style={{ marginTop: 20, marginBottom: 20 }}>
                {this.renderUploadModal(uploaded_respondent_error, uploaded_respondent_data, uploaded_respondent_error_data)}
                {this.renderBreadCrumb()}
                {this.renderInstrumentSelect(instrumentList)}
                {this.renderUploadSection()}
                {this.renderHotTable()}
            </div>
        );
    }

    renderLoader() {
        return (
            <div style={{ height: 'calc(100vh - 150px)' }} className="container d-flex justify-content-center">
                <LoaderComp color={'black'} />
            </div>
        );
    }

    renderUploadModal(uploaded_respondent_error, uploaded_respondent_data, uploaded_respondent_error_data) {
        if (uploaded_respondent_data.message !== '' && this.state.uploadDisability) {
            return (
                <Modal isOpen={this.state.uploadDisability} toggle={this.toggle} centered={true}>
                    <ModalHeader toggle={this.toggle} className="bg-black text-white text-uppercase custom-header">
                        Upload Respondents
                    </ModalHeader>
                    <ModalBody>
                        {this.renderModalBody(uploaded_respondent_data)}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" style={{ borderRadius: 0, margin: '0 10px' }} onClick={this.toggle}>OK</Button>
                    </ModalFooter>
                </Modal>
            );
        } else if (uploaded_respondent_error) {
            return (
                <Modal isOpen={this.state.uploadDisability} toggle={this.toggle} centered={true}>
                    <ModalHeader toggle={this.toggle} className="bg-black text-white text-uppercase custom-header">
                        Error Occurred!
                    </ModalHeader>
                    <ModalBody>
                        {uploaded_respondent_error_data}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" style={{ borderRadius: 0, margin: '0 10px' }} onClick={this.toggle}>OK</Button>
                    </ModalFooter>
                </Modal>
            );
        }
        return null;
    }

    renderModalBody(uploaded_respondent_data) {
        return (
            <React.Fragment>
                {uploaded_respondent_data.errors.length === this.state.csvData.length - 1 ?
                    <p style={{ fontSize: 20, textAlign: 'center', color: 'red' }}>Upload Failed</p> :
                    <p style={{ fontSize: 20, textAlign: 'center', color: 'green' }}>{uploaded_respondent_data.message}</p>
                }
                <div style={{ fontSize: 14 }}>
                    {uploaded_respondent_data.errors.length !== 0 &&
                        <p style={{ fontSize: 12, marginTop: '2.4rem' }}>Following respondents could not be added because of the following errors.</p>
                    }
                    {uploaded_respondent_data.errors.map((val, index) => (
                        <div key={index} style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 2fr' }}>
                            <p style={{ textDecoration: 'underline' }}>{Object.keys(val)[0]}</p>
                            <p>:</p>
                            <p>{val[Object.keys(val)[0]]}</p>
                        </div>
                    ))}
                </div>
            </React.Fragment>
        );
    }

    renderBreadCrumb() {
        return (
            <CommonBreadCrumb
                data={[
                    { link: '/admin/app/dashboard', name: 'ADMIN' },
                    { link: '/admin/app/organisation', name: 'ORGANISATION' },
                    { link: `/admin/app/organisation/${this.state.orgId}`, name: 'ORGANISATION DETAILS' },
                    { link: '', name: 'UPLOAD RESPONDENTS' }
                ]}
            />
        );
    }

    renderInstrumentSelect(instrumentList) {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-6" style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                        <p>Instrument<span className="mandatory-star">*</span></p>
                        <select value={this.state.currentInstrumentId} style={{ width: 250 }} onChange={this.chooseInstrument}>
                            <option>Choose an Option...</option>
                            {instrumentList.map((val, index) =>
                                val.organisation_assessment_credit__instrument__instrument_name !== 'VVI' && (
                                    <option key={index} value={val.organisation_assessment_credit__instrument}>
                                        {val.organisation_assessment_credit__instrument__instrument_name}
                                    </option>
                                )
                            )}
                        </select>
                    </div>
                </div>
            </div>
        );
    }

    renderUploadSection() {
        return (
            <React.Fragment>
                <div className="instrument-select-message">
                    <p>** Please select an instrument</p>
                </div>
                <div className="bg-green rounded-top animation-fade-in">
                    <p className="text-center text-uppercase py-2 text-white mb-0">RESPONDENTS UPLOAD</p>
                </div>
                <div className="container animation-fade-in" style={{ backgroundColor: '#5e5e5e' }}>
                    <div className="row p-2" >
                        <div className="pl-2 pr-2" style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                            <button className="btn btn-red btn-sm text-uppercase m-1" onClick={() => this.chooseFileFunc(true)}>
                                CHOOSE FILE
                            </button>
                            <button className="btn btn-red btn-sm text-uppercase m-1" disabled={!this.state.validateDisability} onClick={this.validateCsvFunc}>
                                {this.state.validationText}
                            </button>
                            <button className="btn btn-red btn-sm text-uppercase m-1" style={{ width: 100 }} disabled={!this.state.uploadDisability} onClick={this.uploadCsvFunc}>
                                {this.state.uploadButtonLoader ? <i className="fa fa-spinner fa-spin"></i> : 'UPLOAD'}
                            </button>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    renderHotTable() {
        return (
            <HotTable
                data={this.state.csvData}
                colHeaders={true}
                rowHeaders={true}
                beforeChange={this.cellbeforechange}
                width="100%"
                className={"animation-fade-in"}
                height="600"
                stretchH="all"
                readOnly={this.state.readOnlyCsv}
                columns={this.getHotTableColumns()}
                afterValidate={this.hotAfterValidate}
                cells={this.getCellProperties}
            />
        );
    }

    getHotTableColumns() {
        return [
            {
                validator: cellValidation.isEmailAddress,
                placeholder: 'Email address',
                placeholderCellClassName: 'hot-placeholder',
            },
            {
                validator: cellValidation.isEmailAddress,
                placeholder: 'Email address',
                placeholderCellClassName: 'hot-placeholder',
            },
            {},
            {},
            {
                placeholder: 'Select Gender',
                editor: 'select',
                selectOptions: ['Female', 'Male', 'Others']
            },
            {
                placeholder: 'Select Relation',
                placeholderCellClassName: 'hot-placeholder',
                editor: 'select',
                selectOptions: [...this.state.relationDataArr]
            }
        ];
    }

    getCellProperties = (row, col, prop) => {
        const cellProperties = {};

        if (row === 0) {
            cellProperties.readOnly = true;
        }

        this.state.errSaveIndex.forEach(indexes => {
            indexes.col.forEach(colD => {
                if (row === indexes.row && col === colD) {
                    cellProperties.className = 'cellErrorInvalid';
                }
            });
        });

        return cellProperties;
    }

    renderChooseFileModal(chooseFile) {
        if (!chooseFile) return null;

        return (
            <ModalNew2
                heading="CHOOSE FILE"
                showModal={chooseFile}
                formData={[{
                    key: 'chooseFile',
                    type: 'file',
                    accept: '.csv',
                    value: '',
                    valid: false,
                    regex: ".+",
                    elementConfig: {
                        name: 'chooseFile',
                        label: '',
                        placeholder: 'Choose a file'
                    },
                    validation: {
                        required: false,
                        message: "is required"
                    },
                }]}
                action={this.chooseFileAction}
                toggleModal={() => this.chooseFileFunc(false)}
                viewMessage={[{ text: '' }]}
                triggerType={"CANCEL"}
                singleButton={true}
                onlyCancel={true}
            />
        );
    }
}

const mapStateToProps = state => {

    const orgError = state.organisation.error;
    const orgLoading = state.organisation.loading;
    const organisationList = (!orgError && !orgLoading) ? state.organisation.organisation.data.organisation_list : [];

    const { batch_list_error, batch_list_loading } = state.managaBatchList;
    const batchList = (!batch_list_error && !batch_list_loading) ? state.managaBatchList.batch_list.data.organisation_batch_list : [];

    const { instrument_list_error, instrument_list_loading } = state.instrumentList;
    const instrumentList = (!instrument_list_error && !instrument_list_loading) ? state.instrumentList.instrument_list.data.organisation_credit_list : [];

    const { uploaded_respondent_error, uploaded_respondent_loading, uploaded_respondent_error_data } = state.uploadRespondent;
    const uploaded_respondent_data = (!uploaded_respondent_error && !uploaded_respondent_loading) ? state.uploadRespondent.uploaded_respondent_data : { errors: [], message: '' }


    return (
        {

            demoGraphicCsvUpload: state.demoGraphicCsvUpload,

            organisationList,
            orgError,
            orgLoading,

            batch_list_error,
            batch_list_loading,
            batchList,

            instrument_list_error,
            instrument_list_loading,
            instrumentList,

            uploaded_respondent_error,
            uploaded_respondent_loading,
            uploaded_respondent_data,
            uploaded_respondent_error_data,

        }
    )
}

UploadAssessment.propTypes = {
    // From mapStateToProps
    demoGraphicCsvUpload: PropTypes.object,
    organisationList: PropTypes.array,
    orgError: PropTypes.bool,
    orgLoading: PropTypes.bool,
    batch_list_error: PropTypes.bool,
    batch_list_loading: PropTypes.bool,
    batchList: PropTypes.array,
    instrument_list_error: PropTypes.bool,
    instrument_list_loading: PropTypes.bool,
    instrumentList: PropTypes.array,
    uploaded_respondent_error: PropTypes.bool,
    uploaded_respondent_loading: PropTypes.bool,
    uploaded_respondent_data: PropTypes.object,
    uploaded_respondent_error_data: PropTypes.string,
  
    // From react-redux connect
    dispatch: PropTypes.func.isRequired,
  
    // From react-router
    location: PropTypes.object.isRequired,
  };




export default connect(mapStateToProps)(UploadAssessment)


// WEBPACK FOOTER //
// ./src/_pages/Admin/Organisation/DetailLinks/UploadRespondent.js